import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path: '/organization',
    name: 'organization',
    meta: { title: '组织管理' },
    component: () => import('@/views/organization/index'),
  },
  {
    path: '/addOrgan',
    name: 'addOrgan',
    meta: { title: '组织管理' },
    component: () => import('@/views/organization/addOrgan'),
  },
  {
    path: '/position',
    name: 'position',
    meta: { title: '职位管理' },
    component: () => import('@/views/position/index'),
  },
  {
    path: '/addPosition',
    name: 'addPosition',
    meta: { title: '职位管理' },
    component: () => import('@/views/position/addPosition'),
  },
  {
    path: '/personnel',
    name: 'personnel',
    meta: { title: '人员管理' },
    component: () => import('@/views/personnel/index'),
  },
  {
    path: '/addPersonnel',
    name: 'addPersonnel',
    meta: { title: '人员管理' },
    component: () => import('@/views/personnel/addPersonnel'),
  },
  {
    path: '/userResource',
    name: 'userResource',
    meta: { title: '授权资源' },
    component: () => import('@/views/personnel/userResource'),
  },
  {
    path: '/userLimits',
    name: 'userLimits',
    meta: { title: '授权权限' },
    component: () => import('@/views/personnel/userLimits'),
  },
  {
    path: '/selectCheckOrg',
    name: 'selectCheckOrg',
    meta: { title: '选择组织' },
    component: () => import('@/views/personnel/selectCheckOrg'),
  },
  {
    path: '/selectOrg',
    name: 'selectOrg',
    meta: { title: '选择组织' },
    component: () => import('@/views/selectOrg/index'),
  },
  {
    path: '/empowerRole',
    name: 'empowerRole',
    meta: { title: '授权角色' },
    component: () => import('@/views/personnel/empowerRole'),
  },
  {
    path: '/roles',
    name: 'roles',
    meta: { title: '角色管理' },
    component: () => import('@/views/roles/index'),
  },
  {
    path: '/addRoles',
    name: 'addRoles',
    meta: { title: '角色管理' },
    component: () => import('@/views/roles/addRoles'),
  },
  {
    path: '/resource',
    name: 'resource',
    meta: { title: '授权资源' },
    component: () => import('@/views/roles/resource'),
  },
  {
    path: '/roleLimits',
    name: 'roleLimits',
    meta: { title: '授权权限' },
    component: () => import('@/views/roles/roleLimits'),
  },
  {
    path: '/roleFunnel',
    name: 'roleFunnel',
    meta: { title: '授权权限' },
    component: () => import('@/views/roles/roleFunnel'),
  },
  {
    path: '/customLimits',
    name: 'customLimits',
    meta: { title: '授权权限' },
    component: () => import('@/views/roles/customLimits'),
  },
  {
    path: '/funnel',
    name: 'funnel',
    meta: { title: '经营数据' },
    component: () => import('@/views/funnel/index'),
  },
  {
    path: '/funnelConfig',
    name: 'funnelConfig',
    meta: { title: '漏斗配置' },
    component: () => import('@/views/funnel/config'),
  },
  {
    path: '/funnelTarget',
    name: 'funnelTarget',
    meta: { title: '漏斗目标' },
    component: () => import('@/views/funnel/target'),
  },
  {
    path: '/actManage',
    name: 'actManage',
    meta: { title: '活动管理' },
    component: () => import('@/views/activityManage/index'),
  },
  {
    path: '/activity',
    name: 'activity',
    meta: { title: '漏斗活动管理' },
    component: () => import('@/views/activityManage/activity'),
  },
  {
    path: '/funnelManage',
    name: 'funnelManage',
    meta: { title: '漏斗管理' },
    component: () => import('@/views/funnel/manage'),
  },
  {
    path: '/orgSelect',
    name: 'orgSelect',
    meta: { title: '绑定机构' },
    component: () => import('@/views/funnel/orgSelect'),
  },
]
const router = new VueRouter({
  scrollBehavior: () => ({ y: 0 }),
  routes,
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
export default router
